<label class="label" [for]="id()">
  {{ label() }}
  @if (showOptional()) {
    <span class="label-optional">{{ optionalText }}</span>
  }
</label>
